import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { routing } from "./admin-routing.module";

// MODULES/MODULOS  -------------------------------------------------------
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { MatExpansionModule } from '@angular/material';
import { ShareModule } from '@asambleas-modules/share/share.module';

import { AdminService } from '@asambleas-services/admin/admin.service';
import { MemberService } from '@asambleas-services/member/member.service';
import { PlanterService } from '@asambleas-services/planter/planter.service';
import { MinisterService } from '@asambleas-services/minister/minister.service';
import { ChurchService } from '@asambleas-services/church/church.service';
import { IglesiasService } from '@asambleas-services/iglesias/iglesias.service';

// COMPONENTS/COMPONENTES  ------------------------------------------------
import { PlanterFormModalComponent } from '@asambleas-components/modals/planter-form-modal/planter-form-modal.component';
import { EditSeederGroupDataComponent } from '@asambleas-components/modals/edit-seeder-group-data/edit-seeder-group-data.component';
import { EditSeederGroupMetricsComponent } from '@asambleas-components/modals/edit-seeder-group-metrics/edit-seeder-group-metrics.component';
import { ExtensionComponent } from './pages/extension/extension.component';
import { AdminComponent } from './admin.component';
import { HomeComponent } from './pages/home/home.component';
import { MasiveRegistrationCsvComponent } from './pages/masive-registration-csv/masive-registration-csv.component';
import { CargarIglesiasCsvComponent } from './pages/cargar-iglesias-csv/cargar-iglesias-csv.component';
import { IglesiasComponent } from './pages/iglesias/iglesias.component';
import { NuevaIglesiaComponent } from './pages/iglesias/nueva-iglesia/nueva-iglesia.component';
import { ListaIglesiasComponent } from './pages/iglesias/lista-iglesias/lista-iglesias.component';
import { BuscarIglesiaComponent } from './pages/iglesias/buscar-iglesia/buscar-iglesia.component';
import { MembersComponent } from './pages/members/members.component';
import { MemberListComponent } from './pages/members/member-list/member-list.component';
import { MemberDetailComponent } from './pages/members/member-detail/member-detail.component';
import { MemberDetailEditComponent } from './pages/members/member-detail-edit/member-detail-edit.component';
import { MasiveMembersLoadComponent } from './pages/masive-members-load/masive-members-load.component';
import { PlantersListComponent } from './pages/extension/planters-list/planters-list.component';
import { PlantersReportComponent } from './pages/extension/planters-report/planters-report.component';
import { SeederDashComponent } from './pages/extension/seeder-dash/seeder-dash.component';
import { MinistersComponent } from './pages/ministers/ministers.component';
import { MinisterListComponent } from './pages/ministers/minister-list/minister-list.component';
import { MinisterPostulationComponent } from './pages/ministers/minister-postulation/minister-postulation.component';
import { PostulateMinisterComponent } from './pages/ministers/postulate-minister/postulate-minister.component';
import { VerPostulacionComponent } from './pages/ministers/ver-postulacion/ver-postulacion.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { IglesiasPendientesComponent } from './pages/iglesias/iglesias-pendientes/iglesias-pendientes.component';
import { NewChurchComponent } from './pages/iglesias/new-church/new-church.component';
import { RolesComponent } from './pages/roles/roles.component';
import { ListRolesComponent } from './pages/roles/list-roles/list-roles.component';
import { EditRoleComponent } from './pages/roles/edit-role/edit-role.component';
import { RequestsCredentialRenovationComponent } from './pages/ministers/requests-credential-renovation/requests-credential-renovation.component';
import { SeeCredentialRenovationComponent } from './pages/ministers/see-credential-renovation/see-credential-renovation.component';
import { MembersListComponent } from './pages/iglesias/members-list/members-list.component';
import { VerIglesiaComponent } from './pages/iglesias/ver-iglesia/ver-iglesia.component';
import { MemberPageComponent } from '@asambleas-components/member-page/member-page.component';
import { MinisterFilesComponent } from '@asambleas-components/minister-files/minister-files.component';

@NgModule({
    entryComponents: [
        PlanterFormModalComponent,
        EditSeederGroupDataComponent,
        EditSeederGroupMetricsComponent,
        EditRoleComponent
    ],
    providers: [
        AdminService,
        MemberService,
        PlanterService,
        MinisterService,
        ChurchService,
        IglesiasService
    ],
    imports: [
        CommonModule,
        MatExpansionModule,
        FormsModule,
        ShareModule,
        AngularFontAwesomeModule,
        ReactiveFormsModule,
        routing
    ],
    declarations: [
        AdminComponent,
        HomeComponent,
        MasiveRegistrationCsvComponent,
        CargarIglesiasCsvComponent,
        IglesiasComponent,
        NuevaIglesiaComponent,
        ListaIglesiasComponent,
        BuscarIglesiaComponent,
        MembersComponent,
        MemberListComponent,
        MemberDetailComponent,
        MemberDetailEditComponent,
        MasiveMembersLoadComponent,
        PlanterFormModalComponent,
        ExtensionComponent,
        PlantersListComponent,
        PlantersReportComponent,
        SeederDashComponent,
        EditSeederGroupDataComponent,
        EditSeederGroupMetricsComponent,
        MinistersComponent,
        MinisterListComponent,
        MinisterPostulationComponent,
        PostulateMinisterComponent,
        VerPostulacionComponent,
        NotificationsComponent,
        IglesiasPendientesComponent,
        NewChurchComponent,
        RolesComponent,
        ListRolesComponent,
        EditRoleComponent,
        RequestsCredentialRenovationComponent,
        SeeCredentialRenovationComponent,
        MembersListComponent,
        VerIglesiaComponent,
        MemberPageComponent,
        MinisterFilesComponent
    ]
})
export class AdminModule { }



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts